import React from "react";
import { useTranslation } from "react-i18next";
import { Sprout, Target, Smile } from "lucide-react";

const PhilosophySection = () => {
  const { t } = useTranslation();
  return (
    <section id="philosophy" className="py-20 lg:py-32 bg-gradient-to-b from-white to-[#F5F1E8]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-4xl mx-auto">
          {/* Main Quote */}
          <div className="text-center mb-16 space-y-6">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-[#7C9885] rounded-full mb-4">
              <Sprout className="w-8 h-8 text-white" />
            </div>
            <h2 className="text-4xl lg:text-5xl font-serif font-bold text-[#2C3E50] leading-tight">
              "{t('philosophy.quote')}"
            </h2>
            <div className="h-1 w-24 bg-[#7C9885] mx-auto"></div>
          </div>

          {/* Philosophy Cards */}
          <div className="grid md:grid-cols-2 gap-8 mt-16">
            <div className="bg-white rounded-xl p-8 shadow-lg border-2 border-[#EDE7DC] hover:border-[#7C9885] transition-all duration-300">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#7C9885]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Target className="w-6 h-6 text-[#7C9885]" />
                </div>
                <div>
                  <h3 className="text-xl font-serif font-bold text-[#2C3E50] mb-3">
                    {t('philosophy.myApproach.title')}
                  </h3>
                  <p className="text-[#5A6B6C] leading-relaxed">
                    {t('philosophy.myApproach.description')}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg border-2 border-[#EDE7DC] hover:border-[#7C9885] transition-all duration-300">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#7C9885]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Smile className="w-6 h-6 text-[#7C9885]" />
                </div>
                <div>
                  <h3 className="text-xl font-serif font-bold text-[#2C3E50] mb-3">
                    {t('philosophy.yourJourney.title')}
                  </h3>
                  <p className="text-[#5A6B6C] leading-relaxed">
                    {t('philosophy.yourJourney.description')}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Motivational Tags */}
          <div className="flex flex-wrap justify-center gap-3 mt-12">
            <span className="px-5 py-2 bg-[#7C9885]/10 text-[#2C3E50] rounded-full text-sm font-medium">
              {t('philosophy.tags.motivation')}
            </span>
            <span className="px-5 py-2 bg-[#7C9885]/10 text-[#2C3E50] rounded-full text-sm font-medium">
              {t('philosophy.tags.yourself')}
            </span>
            <span className="px-5 py-2 bg-[#7C9885]/10 text-[#2C3E50] rounded-full text-sm font-medium">
              {t('philosophy.tags.growth')}
            </span>
            <span className="px-5 py-2 bg-[#7C9885]/10 text-[#2C3E50] rounded-full text-sm font-medium">
              {t('philosophy.tags.healing')}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;